import { createReducer, on } from '@ngrx/store';
import * as Models from '@app/models/ai.model';
import * as AIAction from './ai.actions'; // Import the actions 
import * as AIState from './ai.state'; // Import the state 

export const aiReducer = createReducer(
    AIState.initialState,
    
    // Handle warm up
    on(AIAction.WarmUpSuccess, (state) => (
        {
            ...state,
            initialized: true,
        })
    ),
    // Handle warm up
    on(AIAction.WarmUpFailure, (state, { error }) => (
        {
            ...state,
            errors: {
                ...state.errors, warm_up: error
            },
        })
    ),
    // Handle sending a question - Set loading to true
    on(AIAction.SendQuestion, (state, { question }) => ({
        ...state,
        entries: [
            ...state.entries,
            {
                type: AIState.EntryType.question,
                value: { question: question },  // Store the question content
            }
        ],
        loading: true
    })),

    // Handle the success of sending a question - Add empty answer to entries
    on(AIAction.SendQuestionSuccess, (state, { response }) => (
        {
            ...state,
            entries: [
                ...state.entries,
                {
                    type: AIState.EntryType.answer,
                    value: {
                        question: "",  // Store the question content
                        answer: "",  // Store the question content empty before getting it
                        token: response.token
                    }
                }
            ],
            loading: false,
        })
    ),

    // Handle a failure of sending a question
    on(AIAction.SendQuestionFailure, (state, { error }) => ({
        ...state,
        loading: false,
        entries: [
            ...state.entries,
            {
                type: AIState.EntryType.answer,
                value: {
                    question: "",  // Store the question content
                    answer: "Sorry, but it looks like I cannot answer that question. Your query will be submitted to my colleagues to try to fix that.",  // Store the question content empty before getting it
                    failed: true  // Mark the answer as failed
                }
            }
        ],
        errors: {
            ...state.errors, send_question: error
        },
    })),

    // // Handle fetching an answer - Set loading to true
    // on(AIAction.FetchAnswer, (state, { token }) => ({
    //     ...state,
    //     // loading: true,
    //     error: null,
    // })),

    // Handle the success of fetching an answer - Add the answer to entrie by its token and stop loading
    on(AIAction.FetchAnswerSuccess, (state, { token, response }) => ({
        ...state,
            entries: state.entries.map(entry => {
                if (entry.type === AIState.EntryType.answer) {
                    let answerModel = entry.value as Models.AIAnswerModel;  // Explicitly treat entry.value as AIAnswerModel
                    if (answerModel.token === token) {
                        // If the token matches, return the updated entry
                        return {
                            ...entry,
                            value: {
                                ...answerModel,
                                question: response.question,  // Update the question
                                answer: response.answer       // Update the answer
                            }
                        };
                    }
                }
                // If no match or the entry is not an answer, return the original entry
                return entry;
            }),
        loading: false,
    })),

    // Handle a failure of fetching an answer
    on(AIAction.FetchAnswerFailure, (state, { token, error }) => ({
        ...state,
        entries: state.entries.map(entry => {
            if (entry.type === AIState.EntryType.answer) {
                let answerModel = entry.value as Models.AIAnswerModel;  // Explicitly treat entry.value as AIAnswerModel
                if (answerModel.token === token) {
                    // If the token matches, return the updated entry
                    return {
                        ...entry,
                        value: {
                            ...answerModel,
                            answer: "Sorry, but it looks like I cannot answer that question. Your query will be submitted to my colleagues to try to fix that.",
                            failed: true  // Mark the answer as failed
                        }
                    };
                }
            }
            // If no match or the entry is not an answer, return the original entry
            return entry;
        }),
        loading: false,
        errors: {
            ...state.errors, fetch_answer: error
        },
    }))
);
